import { api_GET, api_POST, api_PUT } from "./_api.js";
import { getSessionCookie } from "../helpers/cookies.js";

const gereciamentoArrecadacao_api = {
  GetConsultaGerenciamentoArrecadacao: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("GerenciamentoArrecadacao/GetConsultaGerenciamentoArrecadacao", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  }
}

export default gereciamentoArrecadacao_api;
